module.exports = __webpack_public_path__ + "static/media/ECO-off.f8ae4557.svg";